import type { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  htmlFor: string
  required?: boolean
  children: ReactNode
  error?: string
}

export function FormField({ label, htmlFor, required = false, children, error }: FormFieldProps) {
  return (
    <div className="form-group">
      <label htmlFor={htmlFor}>
        {label} {required && '*'}
      </label>
      {children}
      {error && <span className="form-error">{error}</span>}
    </div>
  )
}

interface TextInputProps {
  id: string
  value: string
  onChange: (value: string) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  placeholder?: string
  autoFocus?: boolean
  disabled?: boolean
}

export function TextInput({ 
  id, 
  value, 
  onChange, 
  onKeyDown,
  placeholder, 
  autoFocus = false,
  disabled = false 
}: TextInputProps) {
  return (
    <input
      id={id}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      className="form-input"
      autoFocus={autoFocus}
      disabled={disabled}
    />
  )
}

interface TextAreaProps {
  id: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  rows?: number
  disabled?: boolean
}

export function TextArea({ 
  id, 
  value, 
  onChange, 
  placeholder, 
  rows = 3,
  disabled = false 
}: TextAreaProps) {
  return (
    <textarea
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="form-textarea"
      rows={rows}
      disabled={disabled}
    />
  )
}
